module.exports = __webpack_public_path__ + "static/media/flag-ca.cce94d60.svg";